document.querySelectorAll('[data-cta-read-more]').forEach((element) => {
    element.addEventListener('click', function () {
        if(element.closest('.block-content-wrapper') != null){

        let contentBlock = element.closest('.block-content-wrapper').querySelector('.show-more-content');
        let contentHeight = contentBlock.getAttribute('data-content-height')
        const isOpen = contentBlock.classList.contains('show-more');
        
        let contentBlockHeight = contentBlock.scrollHeight;
        
        if (!isOpen) {
            contentBlock.style.height = contentBlockHeight + 'px';
            console.log(contentBlock,"=>",contentBlockHeight)
            setTimeout(() => {
                contentBlock.style.height = '';
            }, 300);
            contentBlock.classList.add('show-more');
            element.closest('.block-content-wrapper').classList.add('open');
            
        } else {
            contentBlock.style.height = contentBlockHeight + 'px';
            setTimeout(function () {
                contentBlock.style.height = contentHeight + 'px';
            }, 1);
            setTimeout(function () {
                contentBlock.classList.remove('show-more');
                element.closest('.block-content-wrapper').classList.remove('open')
            }, 300);
        }
        }
    })
})
document.querySelector('.navbar-desktop-secondary .search__input').addEventListener('focus',ele=>{
    ele.target.closest('.search-form__content').setAttribute('style','z-index: 1;transition: transform .4s ease-out;')
})
document.querySelector('.navbar-desktop-secondary .search__input').addEventListener('focusout',ele=>{
    ele.target.closest('.search-form__content').removeAttribute('style')
})
